class WtDimens {
    constructor() {
        this.leftSidebarMargin = '62px'

        // Border Dimensions
        this.borderRadius = '8px'
        // End of Border Dimensions
    }
}
export const getDimen = new WtDimens()